import { UserContext, UserMutations } from "./types";
import { User } from "@/models/user_schema";
import user from ".";
import { SalesRegionsStringType } from "@/models/map/region_type";


const formatSalesRegion = (str: string): SalesRegionsStringType => {
  if (str.includes('-')) {
        return str.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-') as SalesRegionsStringType;
  } else {
        return str.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') as SalesRegionsStringType;
  }
}


export const addUser = (context: UserContext, userData: User) => {
  if (userData.rep_info) {
    userData.rep_info.sales_region = formatSalesRegion(userData.rep_info.sales_region)
  }
  context.commit(UserMutations.SetUser, userData);
};
